import { ApiUtil as api } from "@/utils/api.util.js";

export class ViewService {
  static URL = process.env.API_URL + process.env.API_VER;
  static RESOURCE = "/view/";

  static firmFirm(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'firm-firm', queryParams);
  }
}



// WEBPACK FOOTER //
// ./src/services/view.service.js